import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../apis/axiosConfig';
import Layout from '../common/Layout';
import { FaDownload, FaCalendarAlt, FaUsers, FaArrowRight, FaSync } from 'react-icons/fa';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api/v1';

function Home() {
  const [allEnquiries, setAllEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/enquiries`);
      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      setAllEnquiries(data);
    } catch (err) {
      console.error('Failed to load enquiries:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const catalogLeads = allEnquiries.filter((item) => (item.type || '').toLowerCase().includes('catalog'));
  const consultationLeads = allEnquiries.filter((item) => !(item.type || '').toLowerCase().includes('catalog'));

  return (
    <Layout>
      <div className="container-fluid p-0">
        {/* Page Title & Refresh */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 pb-3" style={{ borderBottom: '1px solid rgba(196, 168, 130, 0.15)' }}>
          <div>
            <h1 className="h3 mb-1 font-weight-bold" style={{ color: '#ffffff', letterSpacing: '1px' }}>
              ARISTO Enquiry Portal
            </h1>
            <p style={{ color: '#8a8377', fontSize: '13px', margin: 0 }}>
              Overview of all customer leads, catalog requests & consultation bookings.
            </p>
          </div>
          <button onClick={fetchStats} className="btn-gold-outline" title="Refresh Live Data">
            <FaSync className={loading ? 'fa-spin' : ''} /> Refresh
          </button>
        </div>

        {/* 3 Main Stat Cards */}
        <div className="row mb-4">
          {/* Card 1: Total Leads */}
          <div className="col-lg-4 col-md-6 mb-3">
            <div className="luxury-card h-100 d-flex flex-column justify-content-between">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1.5px', color: '#8a8377', fontWeight: 700 }}>
                    Total Enquiries
                  </div>
                  <div style={{ fontSize: '32px', fontWeight: 800, color: '#ffffff', lineHeight: '1.2', marginTop: '4px' }}>
                    {loading ? '...' : allEnquiries.length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                    Overall website captured leads
                  </div>
                </div>
                <div className="icon-box-gold">
                  <FaUsers />
                </div>
              </div>
              <div style={{ paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.06)', fontSize: '12px', color: '#c4a882' }}>
                &bull; Live database sync active
              </div>
            </div>
          </div>

          {/* Card 2: Catalog Downloads */}
          <div className="col-lg-4 col-md-6 mb-3">
            <div className="luxury-card h-100 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1.5px', color: '#8a8377', fontWeight: 700 }}>
                      Catalog Downloads
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: 800, color: '#ffffff', lineHeight: '1.2', marginTop: '4px' }}>
                      {loading ? '...' : catalogLeads.length}
                    </div>
                  </div>
                  <div className="icon-box-gold">
                    <FaDownload />
                  </div>
                </div>
              </div>
              <Link to="/catalog-enquiries" className="btn-gold-outline btn-block text-center mt-2">
                <span>View Download Catalog</span>
                <FaArrowRight size={11} className="ml-1" />
              </Link>
            </div>
          </div>

          {/* Card 3: Enquiry List */}
          <div className="col-lg-4 col-md-12 mb-3">
            <div className="luxury-card h-100 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1.5px', color: '#8a8377', fontWeight: 700 }}>
                      Enquiry List
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: 800, color: '#ffffff', lineHeight: '1.2', marginTop: '4px' }}>
                      {loading ? '...' : consultationLeads.length}
                    </div>
                  </div>
                  <div className="icon-box-gold">
                    <FaCalendarAlt />
                  </div>
                </div>
              </div>
              <Link to="/consultant-enquiries" className="btn-gold btn-block text-center mt-2">
                <span>View Enquiry List</span>
                <FaArrowRight size={11} className="ml-1" />
              </Link>
            </div>
          </div>
        </div>

        {/* Quick Action Cards */}
        <div className="row mb-4">
          <div className="col-md-6 mb-3">
            <div className="luxury-card h-100 d-flex align-items-center justify-content-between">
              <div>
                <h5 className="font-weight-bold mb-1 d-flex align-items-center" style={{ color: '#ffffff' }}>
                  <FaDownload className="mr-2" style={{ color: '#c4a882' }} /> Download Catalog

                </h5>
                <p style={{ color: '#8a8377', fontSize: '12px', margin: 0 }}>
                  Clients who requested PDF catalogs with specifications & finishes.
                </p>
              </div>
              <Link to="/catalog-enquiries" className="btn-gold ml-3 text-nowrap">
                Open Table &rarr;
              </Link>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="luxury-card h-100 d-flex align-items-center justify-content-between">
              <div>
                <h5 className="font-weight-bold mb-1 d-flex align-items-center" style={{ color: '#ffffff' }}>
                  <FaCalendarAlt className="mr-2" style={{ color: '#c4a882' }} /> Enquiry List
                </h5>
                <p style={{ color: '#8a8377', fontSize: '12px', margin: 0 }}>
                  Clients who booked showroom or modular kitchen/wardrobe consultations.
                </p>
              </div>
              <Link to="/consultant-enquiries" className="btn-gold ml-3 text-nowrap">
                Open Table &rarr;
              </Link>
            </div>
          </div>
        </div>

        {/* Recent Enquiries Live Feed */}
        <div className="luxury-table-container">
          <div className="d-flex justify-content-between align-items-center p-3 px-4" style={{ backgroundColor: '#100f0c', borderBottom: '1px solid rgba(196, 168, 130, 0.15)' }}>
            <h5 className="font-weight-bold mb-0" style={{ color: '#c4a882', fontSize: '15px', letterSpacing: '0.5px' }}>
              Recent Enquiries (Live Feed)
            </h5>
            <span style={{ fontSize: '11px', color: '#8a8377', fontWeight: 600 }}>
              {allEnquiries.slice(0, 5).length} latest records
            </span>
          </div>

          <div className="table-responsive">
            <table className="luxury-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Client Name</th>
                  <th>Type</th>
                  <th>Contact Info</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {allEnquiries.slice(0, 5).map((item, idx) => {
                  const isCatalog = (item.type || '').toLowerCase().includes('catalog');
                  return (
                    <tr key={item.id || idx}>
                      <td style={{ fontSize: '12px', color: '#8a8377', whiteSpace: 'nowrap' }}>
                        {item.date_updated ? new Date(item.date_updated).toLocaleDateString() : 'N/A'}
                      </td>
                      <td style={{ fontWeight: 600, color: '#ffffff' }}>
                        {item.name || 'Anonymous'}
                      </td>
                      <td>
                        <span
                          style={{
                            fontSize: '10px',
                            fontWeight: 700,
                            padding: '3px 8px',
                            borderRadius: '4px',
                            backgroundColor: isCatalog ? 'rgba(196, 168, 130, 0.15)' : 'rgba(255, 255, 255, 0.1)',
                            color: isCatalog ? '#c4a882' : '#ffffff',
                            border: `1px solid ${isCatalog ? 'rgba(196, 168, 130, 0.3)' : 'rgba(255, 255, 255, 0.2)'}`,
                          }}
                        >
                          {item.type || 'Consultation'}
                        </span>
                      </td>
                      <td style={{ fontSize: '13px', color: '#ccc' }}>
                        {item.mobile || item.email || 'N/A'}
                      </td>
                      <td style={{ fontSize: '12px', color: '#8a8377', maxWidth: '300px' }} className="text-truncate">
                        {item.message || '-'}
                      </td>
                    </tr>
                  );
                })}
                {allEnquiries.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center py-4" style={{ color: '#8a8377' }}>
                      No enquiries recorded yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
